<template>
    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
        <md-card class="dashboard-platform" :class="cardClasses" @click.native="actionRedirect">
            <div>
                <img v-if="isDFS" src="../../assets/images/dfs_logo.png"> 
                <img v-if="isCompliance" src="../../assets/images/compliance_logo.png"> 
                <img v-if="isOldAcademy || isNewAcademy" src="../../assets/images/academy_logo.png"> 
                {{name}}
            </div>

            <small v-if="!hasAccess && !isNewAcademy && isAdmin" @click="actionShowModal">{{$t('Do you have an account to pair?')}}</small>
        </md-card>
        <account-pair-modal :show-modal="showModal"/>
    </div>
</template>

<script>
    import AccountPairModal from "../modals/AccountPairModal";
    import {mapGetters} from "vuex";
    import UrlMap from "../../js/slug-to-url-map";

    export default {
        name: "DashboardPlatform",
        components: {AccountPairModal},
        props: {
            data: {
                type: Object,
                required: true,
            }
        },
        computed: {
            name() {
                return this.data.name ?? '';
            },
            slug() {
                return this.data.slug ?? '';
            },
            redirectHost() {
                return UrlMap[this.slug] ?? '';
            },
            user() {
                return this.authenticatedInitData.user ?? {};
            },
            appAccesses() {
                return this.user.accesses ?? [];
            },
            hasAccess() {
                const apps = this.appAccesses.find(appAccess => appAccess.appSlug === this.slug) ?? {};
                return apps.hasAccess ?? false;
            },
            isActive() {
                let appAccesses = this.appAccesses.find(appAccess => {
                    return appAccess.appSlug === this.slug;
                }) ?? {};

                return appAccesses.isActive ?? false;
            },
            cardClasses() {
                return {
                    'disabled': !this.hasAccess || !this.isActive,
                }
            },
            isNewAcademy() {
                return this.slug === this.$enums.PlatformSlugEnum.NEW_ACADEMY;
            },
            isOldAcademy() {
                return this.slug === this.$enums.PlatformSlugEnum.ACADEMY;
            },
            isDFS() {
                return this.slug === this.$enums.PlatformSlugEnum.DFS;
            },
            isCompliance() {
                return this.slug === this.$enums.PlatformSlugEnum.COMPLIANCE;
            },
            isAdmin() {
                return this.user.scopes && this.user.scopes.includes('admin');
            },
            ...mapGetters('app', {
                authenticatedInitData: 'getAuthenticatedInitData',
            })
        },
        data() {
            return {
                showModal: false,
            }
        },
        methods: {
            actionShowModal() {
                this.showModal = true;
            },
            actionRedirect() {
                if (this.hasAccess && this.isActive) {

                    if (this.isNewAcademy) {
                        window.open(this.redirectHost, '_blank');
                    }else
                    window.location.href = this.redirectHost;
                }
            }
        }
    }
</script>

<style lang="scss">
    .dashboard-platform {
        padding: 28px !important;
        cursor: pointer;
        background-image: url("../../assets/images/platform-tile-bg.jpg") !important;
        background-repeat: repeat-x !important;
        background-position: top center !important;

        div {
            font-weight: 700 !important;
            font-size: 14px !important;
        }

        img {
            height: 48px !important;
            width: 48px !important;
            margin-right: 12px;
        }

        small {
            position: absolute;
            top: calc(100% + 12px);
            left: 50%;
            transform: translateX(-50%);
            text-align: center;
            cursor: pointer;

            &:hover {
                text-decoration: underline;
            }
        }

        &.disabled {
            cursor: default;
            background-image: url("../../assets/images/platform-tile-bg-disabled.jpg") !important;

            img {
                filter: grayscale(100%);
            }
        }
    }
</style>
